import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { OpportunityService } from './services/opportunity.service';

export function provideOutlookOpportunityDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([OpportunityService]);
}
